import { cx } from "@/utils";

import styles from "./Tabs.module.css";

export type TabNavigationProps = {
  children: React.ReactNode;
  className?: string;
};

const TabNavigation: React.FunctionComponent<TabNavigationProps> = ({
  children,
  className,
}) => {
  return (
    <>
      <nav className={cx(styles.root, className)} data-testid="tabs-nav">
        {children}
      </nav>
    </>
  );
};
export default TabNavigation;
